import { render, staticRenderFns } from "./CreateContactsTab.vue?vue&type=template&id=d8094604&scoped=true"
import script from "./CreateContactsTab.vue?vue&type=script&lang=js"
export * from "./CreateContactsTab.vue?vue&type=script&lang=js"
import style0 from "./CreateContactsTab.vue?vue&type=style&index=0&id=d8094604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8094604",
  null
  
)

export default component.exports